import { Segment } from "./segment";
import { Bounds, mergeBounds } from "./bounds";
import { Matrix } from "./matrix";
import { Pt } from "./pt";

function id(pt: Pt) {
  return pt.x + "," + pt.y;
}

class Chain {
  segments: Segment[];

  constructor(segments: Segment[]) {
    this.segments = segments;
  }

  get start() {
    return this.segments[0].start;
  }

  get end() {
    return this.segments[this.segments.length - 1].end;
  }

  get srcId(): string {
    return id(this.start);
  }

  get destId(): string {
    return id(this.end);
  }

  get bounds(): Bounds {
    return mergeBounds(this.segments.map((s) => s.bounds));
  }

  get isClockwise(): boolean {
    return true; //TODO
  }

  transform(matrix: Matrix): Chain {
    return new Chain(this.segments.map((s) => s.transform(matrix)));
  }

  reverse(): Chain {
    let s = this.segments.map((s) => s.reverse());
    s.reverse();
    return new Chain(s);
  }

  position(t: number): Pt {
    const totalLength = this.segments
      .map((s) => length(s))
      .reduce((a, b) => a + b, 0);
    const threshold = totalLength * t;
    var offset = 0;

    for (let s of this.segments) {
      const l = length(s);
      if (threshold < offset + l) {
        return s.position((threshold - offset) / l);
      }
      offset += l;
    }
  }

  endpoints(start: Pt, end: Pt): Chain {
    if (start === this.start && end === this.end) return this;
    const newSegments = [].concat(this.segments);
    newSegments[0] = newSegments[0].endpoints(start, newSegments[0].end);
    newSegments[newSegments.length - 1] = newSegments[
      newSegments.length - 1
    ].endpoints(newSegments[newSegments.length - 1].start, end);
    return new Chain(newSegments);
  }
}

function length(s: Segment) {
  const dx = s.end.x - s.start.x;
  const dy = s.end.y - s.start.y;
  return Math.sqrt(dx * dx + dy * dy);
}

export { Chain };
